<template>
  <div class="xy-el-menu">
    <el-menu :default-active=active @select="select">
      <div style="clear:both;height:50px;"></div>
      <el-menu-item index="/">
        <span slot="title"><i class="iconfont">&#xe60b;</i>&nbsp;&nbsp;首页</span>
      </el-menu-item>
      <!-- <el-menu-item index="/index">
        <span slot="title"><i class="iconfont">&#xe65f;</i>&nbsp;&nbsp;智能报告</span>
      </el-menu-item>-->
      <el-submenu index="1">
        <template slot="title">
          <span slot="title"><i class="iconfont">&#xe65f;</i>&nbsp;&nbsp;智能报告</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/index">&nbsp;A股</el-menu-item>
          <el-menu-item index="/hk">&nbsp;港股</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/myReports">
        <span slot="title"><i class="iconfont">&#xe600;</i>&nbsp;&nbsp;我的报告</span>
      </el-menu-item>
      <el-menu-item index="/service">
        <span slot="title"><i class="iconfont">&#xe601;</i>&nbsp;&nbsp;服务支持</span>
      </el-menu-item>
    </el-menu>

    <el-row class="userPrice">
      <template v-if="userPrice && userPrice.PERSONAL">
        <el-col :span="22" :offset="1">
          <el-row>
            <span class="priceTitle"><b>个人购买
                <el-popover placement="right" @show="loadBuyLogs" trigger="click">
                  <el-table :data="buyLogsPage.records" cell-class-name="logTable" size="mini"
                    header-row-class-name="priceHeadContainer">
                    <el-table-column width="100" label="购买日期">
                      <template slot-scope="scope">
                        <span v-if="scope.row.expireTime < Date.now()" style="color:#ccc">
                          {{ scope.row.createTime | timeFilter }}
                        </span>
                        <span v-else>
                          {{ scope.row.createTime | timeFilter }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="权益类型">
                      <template slot-scope="scope">
                        <span v-if="scope.row.expireTime < Date.now()" style="color:#ccc">
                          {{ scope.row.packageName }}
                        </span>
                        <span v-else>
                          {{ scope.row.packageName }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="剩余次数">
                      <template slot-scope="scope">
                        <span v-if="scope.row.expireTime < Date.now()" style="color:#ccc">
                          {{ scope.row.restCount }}
                        </span>
                        <span v-else>
                          {{ scope.row.restCount }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column width="100" label="有效期">
                      <template slot-scope="scope">
                        <span v-if="scope.row.expireTime < Date.now()" style="color:#ccc">
                          {{ scope.row.expireTime | timeFilter }}
                        </span>
                        <span v-else>
                          {{ scope.row.expireTime | timeFilter }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额">
                      <template slot-scope="scope">
                        <span v-if="scope.row.expireTime < Date.now()" style="color:#ccc">
                          {{ scope.row.price | priceFilter }}
                        </span>
                        <span v-else>
                          {{ scope.row.price | priceFilter }}
                        </span>

                      </template>
                    </el-table-column>
                  </el-table>
                  <br>
                  <el-pagination background @current-change="loadBuyLogs" layout="prev, pager, next"
                    :page-size="parseInt(buyLogsPage.size)" :total="parseInt(buyLogsPage.total)">
                  </el-pagination>
                  <el-link :underline="false" slot="reference"> <i class="el-icon-warning"></i></el-link>
                </el-popover>
              </b></span>
            <el-row style="margin:5px 0px">
              <el-col :span="15"
                class="priceTitle t_l">{{ userPrice.PERSONAL.fileType === 'PDF' ? 'PDF' : userPrice.PERSONAL.fileType === 'DOC' ? 'word' : '' }}剩余下载次数</el-col>
              <el-col :span="9" class="priceTitle t_r"
                style="color:#2794fd">{{ userPrice.PERSONAL.restCount }}/{{ userPrice.PERSONAL.limitCount }}</el-col>
            </el-row>
            <el-col :span="24">
              <el-progress color="#2794fd" :show-text=false :stroke-width="15"
                :percentage="(100 * userPrice.PERSONAL.restCount / (userPrice.PERSONAL.limitCount || 1))"></el-progress>
            </el-col>
          </el-row>

          <br><br>
        </el-col>
      </template>
      <template v-if="userPrice && userPrice.ORGANIZE && userPrice.ORGANIZE.limitCount">
        <el-col :span="22" :offset="1">
          <el-row>
            <span class="priceTitle"><b>学校购买【当日有效】</b></span>
          </el-row>
          <el-row style="margin:5px 0px">
            <el-col :span="15"
              class="priceTitle t_l">{{ userPrice.ORGANIZE.fileType === 'PDF' ? 'PDF' : userPrice.PERSONAL.fileType === 'DOC' ? 'word' : '' }}剩余下载次数</el-col>
            <el-col :span="9" class="priceTitle t_r"
              style="color:#2794fd">{{ userPrice.ORGANIZE.restCount }}/{{ userPrice.ORGANIZE.limitCount }}</el-col>
          </el-row>
          <el-col :span="24">
            <el-progress color="#2794fd" :show-text=false :stroke-width="15"
              :percentage="(100 * userPrice.ORGANIZE.restCount / (userPrice.ORGANIZE.limitCount || 1))"></el-progress>
          </el-col>
        </el-col>
        <br> <br> <br> <br>
      </template>

    </el-row>

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {

  name: 'HelloWorld',
  data () {
    return {
      active: '',
      userPrice: {},
      buyLogsPage: {
        current: 1,
        size: 3
      },
      userInfo: {}
    }
  },
  mounted: function () {
    let token = this.$route.query.token
    let sign = this.$route.query.sign
    if (!token && !sign) {
      this.getUserPrice()
    }
    this.active = this.$route.path
    let temp = localStorage.getItem('userinfo')
    if (temp) {
      this.userInfo = JSON.parse(temp)
    }
  },

  computed: {
    refeshUserPrice () {
      return this.$store.state.refeshUserPrice
    },
    refreshUserInfo: function () {
      return this.$store.state.refreshUserInfo
    }
  },
  watch: {
    refeshUserPrice: function () {
      this.getUserPrice()
    },
    refreshUserInfo () {
      let temp = sessionStorage.getItem('userinfo')
      if (temp) {
        this.userInfo = JSON.parse(temp)
      }
    }
  },
  filters: {

    timeFilter: function (v) {
      if (v.indexOf('-') === -1) {
        return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
      }
      return moment(new Date(v)).format('YYYY-MM-DD')
    },
    priceFilter: function (v) {
      return (parseInt(v) / 100).toFixed(2) + '元'
    }
  },
  methods: {
    loadBuyLogs (page) {
      if (page) {
        this.buyLogsPage.current = page
      }
      let _this = this
      axios.get('/api/web/price/buyLogs?page=' + this.buyLogsPage.current + '&size=' + this.buyLogsPage.size).then(resp => {
        _this.buyLogsPage = resp.data
      })
    },
    getUserPrice () {
      let _this = this
      axios.get('/api/web/price/mine').then(resp => {
        _this.userPrice = resp.data
      })
    },

    select (path) {
      if (this.$route.path !== path) {
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '打开页面', path])
        this.$router.push({ path: path })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.xy-el-menu {
  width: calc(100% - 15px);
  height: calc(100vh - 60px);
  background-color: #fff;
  box-shadow: 6px 6px 10px 0px #ccc;
  position: relative;

  .userPrice {
    position: absolute;
    bottom: 30px;
    width: 100%;

    .priceTitle {
      font-size: 8px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue